var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeatureIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 95,
    height: 95,
    rx: 16,
    fill: "#FFF5E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47 55C49.1217 55 51.1566 54.1571 52.6569 52.6569C54.1571 51.1566 55 49.1217 55 47C55 44.8783 54.1571 42.8434 52.6569 41.3431C51.1566 39.8429 49.1217 39 47 39C44.8783 39 42.8434 39.8429 41.3431 41.3431C39.8429 42.8434 39 44.8783 39 47C39 49.1217 39.8429 51.1566 41.3431 52.6569C42.8434 54.1571 44.8783 55 47 55ZM47 59C50.1826 59 53.2348 57.7357 55.4853 55.4853C57.7357 53.2348 59 50.1826 59 47C59 43.8174 57.7357 40.7652 55.4853 38.5147C53.2348 36.2643 50.1826 35 47 35C43.8174 35 40.7652 36.2643 38.5147 38.5147C36.2643 40.7652 35 43.8174 35 47C35 50.1826 36.2643 53.2348 38.5147 55.4853C40.7652 57.7357 43.8174 59 47 59ZM45 23H49V31.124C47.6718 30.9583 46.3282 30.9583 45 31.124V23ZM37.188 34.36L31.444 28.616L28.616 31.444L34.36 37.188C35.1814 36.1314 36.1314 35.1814 37.188 34.36ZM31.124 45H23V49H31.124C30.9583 47.6718 30.9583 46.3282 31.124 45ZM34.36 56.812L28.616 62.556L31.444 65.384L37.188 59.64C36.1314 58.8186 35.1814 57.8686 34.36 56.812ZM45 62.876V71H49V62.876C47.6718 63.0419 46.3282 63.0419 45 62.876ZM56.812 59.64L62.556 65.384L65.384 62.556L59.64 56.812C58.8186 57.8686 57.8686 58.8186 56.812 59.64ZM62.876 49H71V45H62.876C63.0419 46.3282 63.0419 47.6718 62.876 49ZM59.64 37.188L65.384 31.444L62.556 28.616L56.812 34.36C57.868 35.18 58.818 36.132 59.64 37.188Z",
    fill: "#F0A81A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureIcon);
export default __webpack_public_path__ + "static/media/feature-icon.76b15c767b927175e104054368792b0d.svg";
export { ForwardRef as ReactComponent };